export default "//cdn.scentbird.com/assets/frontbird-site/images/gucci_124e69.png";